module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_06_770_280_en-c1f3292c784da737555df2dba5e89652.jpg";